import Form from './views/form/Form.vue'

export default {
  name: 'App',
  components: {
    Form
  }
}